import { Divider } from "antd";
import axios from "axios";
import { Button, Dialog, FilePicker, Pane, Text } from "evergreen-ui";
import React, { useState } from "react";
import { AiOutlineFileExclamation } from "react-icons/ai";
import Swal from "sweetalert2";
import { mua } from "../MUA";
import { resolveRoundFlag, useRoundContent } from "../../config/roundContent";

function FileManage({
  REGISTER_SENTVUT_REGISTER,
  STATUS_DOCUMENT,
  Major1_LEVEL_OPEN_NAME,
  ROB_ID,
}) {
  const { content } = useRoundContent(ROB_ID);
  const disableEditVut = resolveRoundFlag(content, "disableEditVut", ROB_ID);
  const [OpenVut, setOpenVut] = useState(false);
  const [OpenCiti, setOpenCiti] = useState(false);
  const [SelectFile, setSelectFile] = useState(null);
  const [SelectFileCiti, setSelectFileCiti] = useState(null);
  const onFileChange = (e) => {
    setSelectFile(e[0]);
  };
  const onFileChangeCiti = (e) => {
    setSelectFileCiti(e[0]);
  };
  const UplodFile = () => {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Basic ${localStorage.getItem("token")}`,
      "content-type": "multipart/form-data",
    };
    var reader = new FileReader();
    reader.readAsDataURL(SelectFile);
    reader.onload = function () {
      let formData = new FormData();
      console.log(reader.result);
      formData.append("File", reader.result);
      axios
        .post(mua + "/admissionnew2022/uploadfile/" + localStorage.getItem("citizent"), formData, {
          headers,
        })
        .then((res) => {
          if (res.data !== 0) {
            Swal.fire({
              icon: "success",
              title: "แก้ไขไฟล์เสร็จสิ้น",
              timer: 1500,
              timerProgressBar: true,
              showConfirmButton: false,
            }).then((res) => {
              window.location.reload();
            });
          }
        });
    };
  };
  const UplodFileCiti = () => {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Basic ${localStorage.getItem("token")}`,
      "content-type": "multipart/form-data",
    };
    var reader = new FileReader();
    reader.readAsDataURL(SelectFileCiti);
    reader.onload = function () {
      let formData = new FormData();
      console.log(reader.result);
      formData.append("File", reader.result);
      axios
        .post(
          mua + "/admissionnew2022/uploadfileCiti/" + localStorage.getItem("citizent"),
          formData,
          { headers }
        )
        .then((res) => {
          if (res.data !== 0) {
            Swal.fire({
              icon: "success",
              title: "แก้ไขไฟล์เสร็จสิ้น",
              timer: 1500,
              timerProgressBar: true,
              showConfirmButton: false,
            }).then((res) => {
              window.location.reload();
            });
          }
        });
    };
  };
  return (
    <div>
      <Text >
        {/* <Text hidden={Major1_LEVEL_OPEN_NAME !== "ครุศาสตรบัณฑิต" && ROB_ID !== "159"}> */}
        สถานะ :{" "}

        {REGISTER_SENTVUT_REGISTER === null ? (
          <Text color="orange">รอการตรวจสอบใบรายงานผลการเรียน</Text>
        ) : REGISTER_SENTVUT_REGISTER === "0" ? (
          <Text color="red">ใบรายงานผลการเรียนไม่ถูกต้อง กรุณาติดต่อ 055-706547</Text>
        ) : REGISTER_SENTVUT_REGISTER === "1" ? (
          <Text color="green">ใบรายงานผลการเรียนผ่านการตรวจสอบ</Text>
        ) : (<></>)}
      </Text>
      <div className="d-flex flex-column " style={{ gap: 8, justifyContent: "space-between" }}>
        <Pane display={"flex"} gap={5} justifyContent="space-between">
          <Button
            width="100%"
            backgroundColor={"#415a77"}
            appearance="minimal"
            color={"#e0e1dd"}
            // marginBottom={10}
            onClick={() => {
              window.open(
                mua +
                "/public/uploaddocument/" +
                localStorage.getItem("citizent") +
                "/" +
                localStorage.getItem("citizent") +
                "_2.pdf"
              );
            }}
          >
            วุฒิการศึกษาที่สำเร็จ
          </Button>
          {REGISTER_SENTVUT_REGISTER !== "1" ? (<Button
            // disabled={REGISTER_SENTVUT_REGISTER === "1"}
            disabled={disableEditVut}
            // disabled
            onClick={() => {
              setOpenVut(true);
            }}
            backgroundColor={"#ffb703"}
            appearance="minimal"
            color={"#023047"}
          >
            แก้ไข
          </Button>) : (<Button
            // disabled={REGISTER_SENTVUT_REGISTER === "1"}
            disabled
            backgroundColor={"#ffb703"}
            appearance="minimal"
            color={"#023047"}
          >
            แก้ไข
          </Button>)}
          
        </Pane>
        <Divider dashed />
        <Text>
          {/* สถานะ :{" "}
          <Text color="orange">รอการตรวจสอบสำเนาบัตรประจำตัว</Text> */}
          {/* {STATUS_DOCUMENT === "0" ? (
            <Text color="orange">รอการตรวจสอบสำเนาบัตรประจำตัว</Text>
          ) : STATUS_DOCUMENT === "2" ? (
            <Text color="red">สำเนาบัตรประจำตัวไม่ถูกต้อง กรุณาติดต่อ 055-706547</Text>
          ) : (
            <Text color="green">สำเนาบัตรประจำตัวผ่านการตรวจสอบ</Text>
          )} */}
        </Text>
        <Pane display={"none"} gap={5} justifyContent="space-between">
          <Button
            width="100%"
            backgroundColor={"#598392"}
            appearance="minimal"
            color={"#e0e1dd"}
            onClick={() => {
              window.open(
                mua +
                "/public/uploaddocument/" +
                localStorage.getItem("citizent") +
                "/" +
                localStorage.getItem("citizent") +
                "_3.pdf"
              );
            }}
          >
            สำเนาบัตรประจำตัว
          </Button>{" "}
          <Button
            disabled
            // disabled={STATUS_DOCUMENT === "1"}
            onClick={() => {
              setOpenCiti(true);
            }}
            backgroundColor={"#ffb703"}
            appearance="minimal"
            color={"#023047"}
          >
            แก้ไข
          </Button>
        </Pane>
      </div>
      <Dialog
        title="แก้ไขไฟล์สำเนาวุฒิการศึกษา"
        hasFooter={false}
        isShown={OpenVut}
        onCloseComplete={() => {
          setOpenVut(false);
        }}
      >
        <FilePicker placeholder="เลือกไฟล์ PDF" accept=".pdf" title="" onChange={onFileChange} />
        <Pane display="flex" paddingY={10} justifyContent="flex-end">
          <Button
            onClick={() => {
              UplodFile();
            }}
            minWidth="100px"
            appearance="primary"
            intent="success"
          >
            บันทึก
          </Button>
        </Pane>
      </Dialog>
      <Dialog
        title="แก้ไขไฟล์สำเนาบัตรประจำตัว"
        hasFooter={false}
        isShown={OpenCiti}
        onCloseComplete={() => {
          setOpenCiti(false);
        }}
      >
        <FilePicker
          placeholder="เลือกไฟล์ PDF"
          accept=".pdf"
          title=""
          onChange={onFileChangeCiti}
        />
        <Pane display="flex" paddingY={10} justifyContent="flex-end">
          <Button
            onClick={() => {
              UplodFileCiti();
            }}
            minWidth="100px"
            appearance="primary"
            intent="success"
          >
            บันทึก
          </Button>
        </Pane>
      </Dialog>
    </div>
  );
}

export default FileManage;
